import {Component, Input, OnInit} from '@angular/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatOption, MatSelect} from '@angular/material/select';
import {forkJoin} from 'rxjs';
import {Section} from '@twpub/core/models';
import {DictionaryService} from '@twpub/core/services';
import {TenantService} from '@twpub/core/services/tenant.service';
import {NotifierService} from '../../services/notifier.service';

@Component({
  selector: 'pub-dictionary-suggestion-settings',
  templateUrl: './dictionary-suggestion-settings.component.html',
  styleUrls: ['./dictionary-suggestion-settings.component.scss'],
  standalone: true,
  imports: [MatFormField, MatLabel, MatSelect, MatOption]
})
export class DictionarySuggestionSettingsComponent implements OnInit {
  /** mat-select value for the "<Disabled>" option — real section ids are always > 0. */
  readonly DISABLED = 0;

  @Input() dictId!: number;

  show = false;
  sections: Section[] = [];
  selectedSectionId = this.DISABLED;

  constructor(private dictService: DictionaryService, private tenantService: TenantService,
              private notifier: NotifierService) {
  }

  ngOnInit(): void {
    forkJoin({
      tenant: this.tenantService.getCurrentTenant(),
      sections: this.dictService.getAllSections(this.dictId)
    }).subscribe({
      next: ({tenant, sections}) => {
        if (!tenant.suggestionsEnabled) {
          this.show = false;
          return;
        }
        this.show = true;
        this.sections = sections;
        this.selectedSectionId = tenant.dictionarySuggestionSections?.[String(this.dictId)] ?? this.DISABLED;
      },
      error: () => {
        this.show = false;
      }
    });
  }

  onSectionChange(value: number): void {
    const previous = this.selectedSectionId;
    this.selectedSectionId = value;
    const sectionId = value === this.DISABLED ? null : value;
    this.tenantService.setDictionarySuggestionSection(this.dictId, sectionId).subscribe({
      next: () => this.notifier.showPopupMessage('Suggestion target updated', 'success'),
      error: () => {
        this.selectedSectionId = previous;
        this.notifier.showPopupMessage('Failed to update suggestion target', 'error');
      }
    });
  }
}
